var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.015,
    height: 24.015,
    viewBox: "0 0 24.015 24.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chart-simple-solid",
    d: "M8.577,34.573A2.573,2.573,0,0,1,11.15,32h1.715a2.573,2.573,0,0,1,2.573,2.573V53.442a2.574,2.574,0,0,1-2.573,2.573H11.15a2.574,2.574,0,0,1-2.573-2.573ZM0,44.865a2.573,2.573,0,0,1,2.573-2.573H4.288a2.574,2.574,0,0,1,2.573,2.573v8.577a2.574,2.574,0,0,1-2.573,2.573H2.573A2.573,2.573,0,0,1,0,53.442Zm21.442-9.434A2.574,2.574,0,0,1,24.015,38V53.442a2.574,2.574,0,0,1-2.573,2.573H19.727a2.574,2.574,0,0,1-2.573-2.573V38a2.574,2.574,0,0,1,2.573-2.573Z",
    transform: "translate(0 -32)",
    fill: "#23b574"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsLogo);
export default __webpack_public_path__ + "static/media/reports-logo.550d6720947316d515dcc2ade8d08b91.svg";
export { ForwardRef as ReactComponent };